import { render, staticRenderFns } from "./BaseFormRadio.vue?vue&type=template&id=981f8534&scoped=true&"
import script from "./BaseFormRadio.vue?vue&type=script&lang=js&"
export * from "./BaseFormRadio.vue?vue&type=script&lang=js&"
import style0 from "./BaseFormRadio.vue?vue&type=style&index=0&id=981f8534&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "981f8534",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VRadio,VRadioGroup,VSubheader})
